import { PureComponent, Fragment } from 'react';

import Button from '@atlaskit/button/new';
import ModalDialog, {
  ModalTitle,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@atlaskit/modal-dialog';

import { OAuthModule, OAuthScope } from './types';

export type OAuthModalProps = {
  module: OAuthModule;
  scopes: OAuthScope[];
};

export class OAuthModal extends PureComponent<OAuthModalProps> {
  static ListItem = ({ name, description, icon }: OAuthScope) => (
    <li key={name} style={{ display: 'flex' }}>
      <span
        className={`aui-icon aui-icon-small ${icon}`}
        style={{ minWidth: '24px' }}
      />
      <span>{description}</span>
    </li>
  );
  static List = ({
    scopes,
    module: mod,
  }: {
    scopes: OAuthScope[];
    module: OAuthModule;
  }) => (
    <Fragment>
      <p>
        <strong>{mod.name}</strong> requests access to:
      </p>
      <ul style={{ listStyleType: 'none', padding: '4px 0 0 0' }}>
        {scopes.reduce(
          (arr, { name, description, icon }) =>
            mod.scopes.includes(name)
              ? [
                  ...arr,
                  <OAuthModal.ListItem
                    key={name}
                    name={name}
                    description={description}
                    icon={icon}
                  />,
                ]
              : arr,
          []
        )}
      </ul>
    </Fragment>
  );
  render() {
    const { accept, deny } = this.props.module;
    return (
      <ModalDialog
        shouldCloseOnEscapePress={false}
        shouldCloseOnOverlayClick={false}
      >
        <ModalHeader>
          <ModalTitle>Review permissions</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <OAuthModal.List {...this.props} />
        </ModalBody>
        <ModalFooter>
          <Button onClick={accept} appearance="primary">
            Allow
          </Button>
          <Button onClick={deny} appearance="subtle">
            Deny
          </Button>
        </ModalFooter>
      </ModalDialog>
    );
  }
}

// eslint-disable-next-line import/no-default-export
export default OAuthModal;
